import React from "react";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import { Text, TouchableHighlight, TouchableOpacity, View } from "react-native";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { useTooltips } from "../../../context/WalkthroughContext";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CropImage } from "../../choose-avatar-components/CropImage";
import Avatar from "../../choose-avatar-components/Avatar";

const WatchingWalkthrough = ({ content }) => {
  const {
    watchingEventTooltipVisible,
    setWatchingEventTooltipVisible,
    setPastEventTooltipVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();
  const deviceSize = useDeviceSize();

  return (
    <View
      style={{
        justifyContent: "center",
      }}
    >
      <Tooltip
        isVisible={watchingEventTooltipVisible}
        contentStyle={{
          backgroundColor: AppColors.purple_453B50,
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 350
              : 736,
          borderColor: AppColors.white,
          shadowColor: "rgba(255, 255, 255, 0.65)",
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 0.65,
          shadowRadius: 10.1,
          elevation: 5,
          borderWidth: 1,
          height: "auto",
        }}
        displayInsets={{
          top:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 100
              : 84,
          bottom: 0,
          left:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 10
              : deviceSize === DEVICE_SIZES.MD || deviceSize === DEVICE_SIZES.LG
              ? 30
              : 374,
          right: 0,
        }}
        arrowStyle={{ display: "none" }}
        content={
          <View>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "column"
                    : "row",
                gap: 10,
              }}
            >
              {" "}
              <TouchableOpacity
                onPress={() => {
                  setWatchingEventTooltipVisible(false);
                }}
                style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
              >
                <ImageComponent
                  url={AppImages.icCloseWhiteSvg}
                  style={{
                    height: 16,
                    width: 16,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>
              <View
                style={{ flexDirection: "row", gap: 10, alignItems: "center" }}
              >
                <Avatar
                  src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  variant="walkthroughPlayer"
                />
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      { color: AppColors.white },
                    ]}
                  >
                    👀 Events I’m Watching – Stay in the Action 👀
                  </Text>
                ) : null}
              </View>
              <View
                style={{
                  flex: 1,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 0
                      : 12,
                }}
              >
                <View>
                  {deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ? null : (
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        { color: AppColors.white, marginBottom: 10 },
                      ]}
                    >
                      👀 Events I’m Watching – Stay in the Action 👀
                    </Text>
                  )}
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { lineHeight: 21 },
                    ]}
                  >
                    Track your favourite events and never miss a key
                    moment—watch top players battle it out and experience the
                    hype.
                  </Text>
                  <View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          🎭 Live Entertainment:{" "}
                        </Text>
                        Enjoy the thrill of competition with real-time action.
                      </Text>
                    </View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          💬 Engage with the Community:{" "}
                        </Text>
                        Chat with fans and support your favourite players.
                      </Text>
                    </View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          🏆 Follow the Winners:{" "}
                        </Text>
                        See who dominates and learn from the best.
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <View
              style={{
                gap: 10,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Text
                style={{
                  ...AppFontStyle.REGULAR_ANYBODY_12,
                  color: AppColors.green_00FFE8,
                }}
              >
                {currentStep + 1} / {totalSteps}
              </Text>

              <TouchableOpacity
                onPress={() => {
                  setWatchingEventTooltipVisible(false);
                  setPastEventTooltipVisible(true);
                  handleNextStep();
                }}
                style={{
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  width: 70,
                  height: 20,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                  cursor: "pointer",
                  shadowColor: "rgba(0, 0, 0, 0.25)",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.25,
                  shadowRadius: 4,
                  elevation: 4,
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
              </TouchableOpacity>
            </View>
          </View>
        }
        placement="bottom"
      >
        <TouchableHighlight>{content}</TouchableHighlight>
      </Tooltip>
    </View>
  );
};

export default WatchingWalkthrough;
